module.exports = __webpack_public_path__ + "static/img/543af563.svg";